import { getClassName } from '@perpay-web/utils/domUtils';
import { noop } from '@perpay-web/utils/noop';

import styles from './BankAccountDisplay.scss';

/**
 * Represents a bank account object
 * @typedef {Object} BankAccount
 * @property {string} uuid - Unique identifier for the bank account
 * @property {string} bankName - Name of the bank
 * @property {string} [nickname] - Nickname of the bank account
 * @property {string} account - Account number
 * @property {string} routing - Routing number
 * @property {string} status - Status of the bank account
 */

/**
 * Renders a bank account display with a radio button
 * @param {Object} props - Component props
 * @param {BankAccount} props.bankAccount - The bank account to display
 * @param {boolean} props.isSelected - Whether the bank account is selected
 * @param {Function} [props.onSelect] - The function to call when the bank account is selected
 * @returns {JSX.Element} The rendered bank account display
 */
const RadioBankAccountDisplay = ({
    bankAccount,
    isSelected,
    onSelect = noop,
}) => (
    <button
        className={getClassName(
            styles['bank-box'],
            styles['radio-mode'],
            isSelected ? styles.selected : '',
        )}
        onClick={onSelect}
        type='button'
    >
        <div className={styles['bank-details']}>
            {bankAccount ? (
                <div>
                    <div className={styles['bank-name-text']}>
                        {bankAccount.nickname || bankAccount.bankName}
                    </div>
                    <div className={styles['bank-account-number']}>
                        Account •• {bankAccount.account}
                    </div>
                </div>
            ) : (
                <div>Add Bank Account</div>
            )}
            <div className={styles['radio-button']}>
                <div
                    className={getClassName(
                        styles['radio-circle'],
                        isSelected ? styles.selected : '',
                    )}
                >
                    {isSelected ? (
                        <div className={styles['radio-dot']} />
                    ) : null}
                </div>
            </div>
        </div>
    </button>
);

export default RadioBankAccountDisplay;
